import {
  AutocompleteInput,
  TextInput,
  ReferenceInput,
  SelectInput,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  SearchInput,
  NumberInput,
} from "react-admin";
import { Grid } from "@mui/material";
import {
  subscriptionDateChoices,
  paymentStatus,
  agreeStatus,
  paymentType,
  subscriptionYearChoices,
} from "../../../utils/options";
import {
  autocompleteInput_style_filter_reference,
  filterStyle,
  filterNumberStyle,
  autocompleteInput_style_filter_reference_many,
  datePickerFilterResponse,
} from "../../../customStyles/ra-custom-styles";
import { AUTORS, DPO, SUBSCRIPTION_COMPANY, THEMATIC_CATALOG_REFS } from "../../../utils/constants";
import CustomDateInput from "common/components/Fields/CustomDateInput";
//опс 1, опс 2 - first&second reference
export const reportDistrictsFirstSecondReferenceFilters = [
  <ReferenceInput
    reference={DPO}
    source="district_id"
    alwaysOn
  >
    <AutocompleteInput
      label="Областна Пощенска станция"
      sx={autocompleteInput_style_filter_reference}
      optionText="name"
    />
  </ReferenceInput>,

  <ReferenceArrayInput
    source="campaign_ids"
    reference={SUBSCRIPTION_COMPANY}
    alwaysOn
  >
    <AutocompleteArrayInput
      optionText="name_bg"
      label="Абонаментна кампания"
      sx={autocompleteInput_style_filter_reference}
      fullWidth
    />
  </ReferenceArrayInput>,

  <AutocompleteInput
    label="Месец на начало на абонамента"
    source="subscription_start_month"
    choices={subscriptionDateChoices}
    alwaysOn
    optionValue="_id"
    sx={autocompleteInput_style_filter_reference_many}
  />,
  <AutocompleteInput
    label="Година на начало на абонамента"
    source="start_year"
    choices={subscriptionYearChoices}
    alwaysOn
    sx={autocompleteInput_style_filter_reference_many}
  />,
  <AutocompleteInput
    label="Статус на плащане"
    choices={paymentStatus}
    source="payment_status"
    alwaysOn
    sx={autocompleteInput_style_filter_reference_many}
  />,
];
// издатели - publishers, издания - editions
export const publishersEditionsFilters = [
  <ReferenceInput
    reference={AUTORS}
    source="publisher_id"
    alwaysOn
  >
    <AutocompleteInput
      label="Издател"
      sx={autocompleteInput_style_filter_reference}
      optionText="publisher_name"
    />
  </ReferenceInput>,

  <ReferenceArrayInput
    source="campaign_ids"
    reference={SUBSCRIPTION_COMPANY}
    alwaysOn
  >
    <AutocompleteArrayInput
      optionText="name_bg"
      label="Абонаментна кампания"
      sx={autocompleteInput_style_filter_reference}
      fullWidth
    />
  </ReferenceArrayInput>,
  <AutocompleteInput
    label="Месец на начало на абонамента"
    source="subscription_start_month"
    choices={subscriptionDateChoices}
    alwaysOn
    optionValue="_id"
    sx={autocompleteInput_style_filter_reference_many}
  />,
  <AutocompleteInput
    label="Година на начало на абонамента"
    source="start_year"
    choices={subscriptionYearChoices}
    alwaysOn
    sx={autocompleteInput_style_filter_reference_many}
  />,
  <SelectInput
    label="Статус на плащане"
    choices={paymentStatus}
    source="payment_status"
    alwaysOn
    emptyText={"Изчисти полето"}
    sx={{ width: "18rem" }}
  />,
];
//справка 3
export const report3 = [
  <ReferenceArrayInput
    source="campaign_ids"
    reference={SUBSCRIPTION_COMPANY}
    alwaysOn
  >
    <AutocompleteArrayInput
      optionText="name_bg"
      label="Абонаментна кампания"
      sx={autocompleteInput_style_filter_reference}
      fullWidth
    />
  </ReferenceArrayInput>,
  <AutocompleteInput
    label="Месец на начало на абонамента"
    source="subscription_start_month"
    choices={subscriptionDateChoices}
    alwaysOn
    optionValue="_id"
    sx={autocompleteInput_style_filter_reference_many}
  />,
  <AutocompleteInput
    label="Година на начало на абонамента"
    source="start_year"
    choices={subscriptionYearChoices}
    alwaysOn
    sx={autocompleteInput_style_filter_reference_many}
  />,
  <SelectInput
    label="Статус на плащане"
    choices={paymentStatus}
    source="payment_status"
    alwaysOn
    emptyText={"Изчисти полето"}
    fullWidth
    sx={{ width: "20rem" }}
  />,
];
//абонаменти
export const subscriptionsFilter = [
  <Grid
    container
    alwaysOn
    style={{ width: "1240px" }}
  >
    <Grid
      item
      xs={3}
      md={3}
    >
      <NumberInput
        sx={filterNumberStyle}
        label="Номер на поръчката"
        source="order_id"
        resettable
        alwaysOn
      />
      <TextInput
        sx={filterStyle}
        label="Име на заявител"
        source="giver_first_name"
        resettable
        alwaysOn
      />
      <TextInput
        sx={filterStyle}
        label="Фамилия на заявител"
        source="giver_last_name"
        resettable
        alwaysOn
      />
      <TextInput
        sx={filterStyle}
        label="Населено място за доставка"
        source="receiver_city"
        resettable
        alwaysOn
      />
      <TextInput
        sx={filterStyle}
        label="Име на получател"
        source="receiver_first_name"
        resettable
        alwaysOn
      />
      <TextInput
        sx={filterStyle}
        label="Фамилия на получател"
        source="receiver_last_name"
        resettable
        alwaysOn
      />
      <NumberInput
        sx={filterStyle}
        label="Пощенски код на получател"
        source="receiver_postcode"
        resettable
        alwaysOn
      />
    </Grid>
    <Grid
      item
      xs={3}
      md={3}
    >
      <CustomDateInput
        sx={datePickerFilterResponse}
        label="Дата на абонамент от"
        source="receiver_order_date_from"
        resettable
        alwaysOn
      />
      <CustomDateInput
        sx={datePickerFilterResponse}
        fullWidth
        label="Дата на абонамент до"
        source="receiver_order_date_to"
        resettable
        alwaysOn
      />
      <NumberInput
        label="Цена на абонамента - от"
        source="minimum_sum"
        resettable
        alwaysOn
        sx={filterStyle}
      />
      <NumberInput
        label="Цена на абонамента - до"
        source="maximum_sum"
        alwaysOn
        sx={filterStyle}
        resettable
      />

      <CustomDateInput
        sx={datePickerFilterResponse}
        label="Дата на плащане от"
        source="purchase_date_from"
        resettable
        alwaysOn
      />
      <CustomDateInput
        sx={datePickerFilterResponse}
        label="Дата на плащане до"
        source="purchase_date_to"
        resettable
        alwaysOn
      />
    </Grid>
    <Grid
      item
      xs={3}
      md={3}
    >
      <AutocompleteInput
        sx={filterStyle}
        label="Метод на плащане"
        source="payment_type"
        choices={paymentType}
        resettable
        alwaysOn
      />
      <AutocompleteInput
        sx={filterStyle}
        label="Статус на плащане"
        choices={paymentStatus}
        source="payment_status"
        resettable
        alwaysOn
      />
      <SelectInput
        sx={filterStyle}
        label="Желае фактура"
        source="is_invoice_ordered"
        choices={agreeStatus}
        alwaysOn
      />
      <SelectInput
        sx={filterStyle}
        label="Издадена фактура"
        source="is_invoice_given"
        choices={agreeStatus}
        alwaysOn
      />
      <TextInput
        sx={filterStyle}
        label="Номер фактура"
        source="invoice_number"
        resettable
        alwaysOn
      />
      <TextInput
        // style={{ marginBottom: "1.5em" }}
        sx={filterStyle}
        label="E-мейл"
        source="giver_email"
        alwaysOn
        resettable
      />
    </Grid>
  </Grid>,
];

export const subjectQueryFilter = query => ({ name: query });

export const orderFilter = [
  <SearchInput
    sx={{ paddingBottom: "5px", marginTop: "-40px" }}
    source="subject"
    alwaysOn
    variant="filled"
    placeholder="Поръчка"
  />,
];

export const messagesFilter = [
  <SearchInput
    sx={{ paddingBottom: "5px", marginTop: "-40px" }}
    source="title"
    alwaysOn
    variant="filled"
    placeholder="Съобщениe"
  />,
];

export const catalogFilter = [
  <ReferenceInput
    source="campaign_id"
    reference={SUBSCRIPTION_COMPANY}
    alwaysOn
  >
    <AutocompleteInput
      optionText="name_bg"
      label="Абонаментна кампания"
      sx={autocompleteInput_style_filter_reference}
      fullWidth
    />
  </ReferenceInput>,
  <TextInput
    label="Заглавие"
    source="title"
    alwaysOn
    resettable
  />,
  <TextInput
    label="Каталожен номер"
    source="catalog_number"
    alwaysOn
    resettable
  />,
];
export const thematicCatalogFilter = [
  <ReferenceInput
    source="thematic_catalog_group_id"
    reference={THEMATIC_CATALOG_REFS}
    alwaysOn
  >
    <AutocompleteInput
      label="Тематичен каталог"
      optionText="name"
      sx={autocompleteInput_style_filter_reference}
      fullWidth
    />
  </ReferenceInput>,
];
export const titleFilter = [
  <TextInput
    label="Заглавие"
    source="title"
    alwaysOn
    resettable
  />,
];
